
import * as api from "../../../api"; 


  
export const createCourseByAdmin = (post) => async (dispatch)=>{
    try {
        const {data } = await api.createCourseByAdmin(post);
        //  console.log(data)
        if(data?.app){
          dispatch({
            type: "APPDATA",
            
            payload:data?.app
          });   dispatch({
            type: "MAINMENU",
            
            payload:""
          });  
          
      }
       
        if(data?.course){
          dispatch({
            type: "COURSEDATA",
            
            payload:data?.course
          });  
       
        }else if(data?.logout){  

          dispatch({type:"LOGOUT"});
        }
        
        
        return data 
     } catch (error) {
        dispatch({
            type: "CourseData",
            
            payload:{"course":null}
          });  
    }
}




  
// export const createCourseByAdminV2 = (apiData) => async (dispatch)=>{
//   try {
//       const {responseData } = await api.createCourseByAdminV2(apiData);
//        console.log(responseData)
//       if(responseData){
       
        
//     }
//       if(responseData?.logout){  

//         dispatch({type:"LOGOUT"});
//       }
      
      
//       return responseData 
//    } catch (error) {
      
//   }
// }

export const createCourseByAdminV2 = (APIData) => async (dispatch)=>{
  try {
      const {data } = await api.createCourseByAdminV2(APIData);
     
      if(data){ 
        dispatch({
          type: "COURSEDATA",
          
          payload:data?.course
        });  
       
        }else if(data?.logout){   dispatch({type:"LOGOUT"});}
      
        return data ;
   } catch (error) {
     
  }
}
export const createPricePlanByAdmin = (APIData) => async (dispatch)=>{
  try {
      const {data } = await api.createPricePlanByAdmin(APIData);
     
      if(data){ 
       
       
        }else if(data?.logout){   dispatch({type:"LOGOUT"});}
      
        return data ;
   } catch (error) {
     
  }
}
export const getAPricePlanByProductId = (APIData) => async (dispatch)=>{
  try {
      const {data } = await api.getAPricePlanByProductId(APIData);
     
      if(data){ 
       
       
        }else if(data?.logout){   dispatch({type:"LOGOUT"});}
      
        return data ;
   } catch (error) {
     
  }
}


export const getProductByProductId = (folderAPIData) => async (dispatch)=>{
  try {
      const {data } = await api.getProductByProductId(folderAPIData);
    // console.log(data)
      if(data){  return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
      
   } catch (error) {
     
  }
}

export const createLabelsByApp = (APIData) => async (dispatch)=>{
  try {
      const {data } = await api.createLabelsByApp(APIData);
    // console.log(data)
      if(data){  return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
      
   } catch (error) {
     
  }
}

